export default "__VITE_ASSET__Bp5geD9d__"